/**
 * Base cart event. Most cart events should have these properties.
 */
import { CxEvent } from '@spartacus/core';
import { EcommerceCartAllProduct, EcommerceModifiedProduct } from './CartEvents.model';

export class CustomCartAddEntrySuccessEvent extends CxEvent {
  /**
   * Event's type
   */
  static readonly type = 'CartAddEntryEvent';
  event: string;
  ecommerce: EcommerceModifiedProduct;
}

export class CustomCartRemoveEntrySuccessEvent extends CxEvent {
  /**
   * Event's type
   */
  static readonly type = 'CartRemoveEntrySuccessEvent';
  event: string;
  ecommerce: EcommerceModifiedProduct;
}

export class CustomCartUpdateEntrySuccessEvent extends CxEvent {
  /**
   * Event's type
   */
  static readonly type = 'CartUpdateEntrySuccessEvent';
  event: string;
  ecommerce: null | EcommerceModifiedProduct;
}

export class CustomViewCartSuccessEvent extends CxEvent {
  /**
   * Event's type
   */
  static readonly type = 'ViewCartSuccessEvent';
  event: string;
  ecommerce: EcommerceCartAllProduct;
}
